<template>
  <div class="register">
    <h3 class="blank-header primary--text">Register</h3>
    <v-flex>
        <v-form
                ref="registrationForm"
                v-model="registrationValid"
                lazy-validation
                @keyup.native.enter="submit"
        >
            <v-alert
                    v-if="message"
                    :value="message.length"
                    :type="message.type"
                    class="mb-3"
            >
              <div v-html="message.message"></div>
            </v-alert>
            <v-text-field
                    type="text"
                    v-model="member_first_name"
                    :rules="[rules.required]"
                    label="First Name"
                    required
            ></v-text-field>
            <v-text-field
                type="text"
                v-model="member_last_name"
                :rules="[rules.required]"
                label="Last Name"
                required
            ></v-text-field>
            <v-text-field
                    type="email"
                    v-model="email"
                    :rules="rules.emailRules"
                    label="E-mail"
                    required
            ></v-text-field>
            <v-text-field
                    v-model="password"
                    :rules="[rules.required, rules.min]"
                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                    :type="showPassword ? 'text' : 'password'"
                    name="input-10-2"
                    label="Password"
                    hint="At least 6 characters"
                    value=""
                    class="input-group--focused"
                    @click:append="showPassword = !showPassword"
            ></v-text-field>
            <v-text-field
                    :append-icon="showPasswordMatch ? 'visibility' : 'visibility_off'"
                    :rules="[rules.required, rules.emailMatch, rules.min]"
                    :type="showPasswordMatch ? 'text' : 'password'"
                    name="input-10-3"
                    label="Confirm Password"
                    @click:append="showPasswordMatch = !showPasswordMatch"
            ></v-text-field>
          <v-btn
                  class="mt-3"
                  color="primary"
                  @click="register"
          >
            Continue
          </v-btn>
        </v-form>
    </v-flex>
    <v-footer color="none" fixed justify-center>
      <v-container justify-center>
        <v-flex class="xs12 sm6 lg4 mx-auto" justify-center>
          <v-layout>
            <router-link to="login" class="footer-link">Already Registered?</router-link>
            <v-spacer></v-spacer>
            <router-link to="forgot" class="footer-link">Forgot Password?</router-link>
          </v-layout>
        </v-flex>
      </v-container>
    </v-footer>
  </div>
</template>

<script>

  import { validationMixin } from 'vuelidate'
  import { mapState } from 'vuex'

  export default {
    created () {

    },
    mixins: [validationMixin],
    data () {
      return {
        registrationValid: true,
        e1: 0,
        email: '',
        password: '',
        club: 0,
        clubs: [],
        guid: null,
        member_first_name: null,
        member_last_name: null,
        challenges: null,
        showPassword: false,
        showPasswordMatch: false,
        rules: {
          emailRules: [
            v => !!v || 'E-mail is required',
            v => {
              if (v.length > 0) {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(v) || 'Invalid e-mail.'
              }
              return false
            }
          ],
          required: value => !!value || 'This field is required.',
          min: v => !v || v.length >= 6 || 'Min 6 characters',
          emailMatch: v => {
            return v === this.password || 'The passwords you entered don\'t match'
          }
        }
      }
    },
    computed: {
      ...mapState({
        challenge: state => state.challenge.challenge
      }),
      baseUrl() {
        return this.$store.getters['settings/baseUrl']
      },
      message() {
        return this.$store.getters['global/message']
      }

    },
    methods: {
      register () {
        if (!this.$refs.registrationForm.validate()) {
          return
        }
        this.$store.commit('global/SET_SYNCING', 'Finalising Registration')
          this.$http.post(this.baseUrl + 'challenge-register', {
            first_name: this.member_first_name,
            last_name: this.member_last_name,
            club_id: this.club,
            email: this.email,
            password: this.password,
            challenge_id: this.challenge ? this.challenge.id : 0
          })
            .then(async response => {
              //console.log(response.data)
              await this.$store.dispatch('auth/setToken', response.data.token)
              await this.$store.dispatch('auth/setUser')
              await this.$store.dispatch('data/getEvoltData', null, {root: true})
              await this.$store.dispatch('data/getWorkoutData', null, {root: true})
              this.$store.commit('global/SET_SYNCING', null)
              this.$router.push('/')
            }).catch(error => {
              console.error(error)
              this.$store.commit('global/SET_SYNCING', null)
              this.$store.dispatch('global/setMessage', {type: 'error', message: error.response.data})
          })

      }
    }
  }
</script>

<style lang="scss">
    .register {
      width: 100%;
    }
    .v-stepper {
      background: transparent !important;
      -webkit-box-shadow: none;
      box-shadow: none;
      &__header {
        -webkit-box-shadow: none;
        box-shadow: none;
      }
      &__content {
        padding-left: 0;
        padding-right: 0;
      }
      &__step {
        padding: 0;
      }
      .v-divider {
        display: block;
        margin-right: 10px;
        margin-left: 10px;
      }

    }
</style>
